export default __webpack_public_path__ + "static/media/1920.8272d015.png";